<template>
    <div>
    <CRUDCriteria :showReset="true" :showSearch="false">
        <template v-slot:criteriaRows>
            <div class="mt-0 ml-6 mr-6 mb-0 pa-0">
            <v-row class="row">
              <v-col cols="2" class="pt-0 pb-0">
                <CommonDropDowns :isItTaxYear=true @change="dataFromCommonDropDowns"
                  :criteriaState="criteriaState" />
            </v-col>
                <v-col cols="3" class="pt-0 pb-0">
                    <ClarionDateControl
                        class="input-text-size"
                        v-model="criteriaState.fromDate"
                        :isToggle="false"
                        @input="searchByTimeOutClarionDate"
                        label="From Date" />
                </v-col>
                <v-col cols="3" class="pt-0 pb-0">
                    <ClarionDateControl
                        class="input-text-size"
                        v-model="criteriaState.toDate"
                        :isToggle="false"
                        @input="searchByTimeOutClarionDate"
                        label="To Date" />
                </v-col>
                <v-col cols="3" class="pt-0 pb-0">
                  <CommonDropDowns :isItTaxAdjTypes=true
                  @change="dataFromCommonDropDowns"
                  :taxAdjTypesValue="taxRollTypes.value"/>
                </v-col>
            </v-row>
            <v-row class="row">
                <v-col cols="3" class="pt-0 pb-0 mt-n6">
                  <CommonDropDowns :isItTaxDistrict=true
                  @change="dataFromCommonDropDowns"
                  :taxDistrictValue="criteriaState.schoolDistrict"/>
                </v-col>
                <v-col cols="4" class="pt-0 pb-0 mt-n6">
                    <v-text-field class="input-text-size"
                    v-uppercase=globalSettingItem.conEverythingToCaps
                      v-model="criteriaState.wildcard"
                      @input="wildcardSearchDelayed"
                      autocomplete="off"
                    >
                        <template v-slot:label>
                            <label class="label">Wildcard Search (Tax ID, Tax Amount,
                                 cert #, comments)</label>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col cols="4" class="pt-0 pb-0 mt-n6">
                <v-checkbox class="input-text-size"
                  @change="searchByCriteria"
                  v-model="criteriaState.posted" label="Include Posted" />
                </v-col>
            </v-row>
        </div>
        </template>
    </CRUDCriteria>
</div>
</template>

<script>
import {
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
import ClarionDateControl from '@/components/common/ClarionDateControl.vue';
import CommonDropDowns from '../common-utils/CommonDropDowns.mixin.vue';
import CRUDCriteria from '../../common/base/crud-2.0/CRUDCriteria.vue';
import { makeCriteriaStateNullIfEmptyString } from '../common-utils/CommonTaxFunctionalities';
import GlobalToCaps from '../../../util/shared/GlobalToCaps.mixin.vue';

import '../../../assets/style.css';
import { SEARCH_DEBOUNCE_TIMER } from '../common-utils/constants';
// import FySelect from '../../common/FySelect.vue';

const taxRollTypeCrudKey = 'taxAdjTypesList';
const taxDistrictBaseCrudKey = 'sharedTaxDistrict';

export default {
  mixins: [GlobalToCaps],
  data() {
    return {
      checkbox: true,
      delayTimerId: null,
    };
  },
  created() {
    this.criteriaState.posted = true;
  },
  props: {
    baseCrudKey: {
      type: String,
      default: 'default',
    },
  },
  components: {
    ClarionDateControl,
    CRUDCriteria,
    // FySelect,
    CommonDropDowns,
  },
  computed: {
    ...mapGetters('base/crud', ['criteria', 'item', 'items']),
    ...mapState({
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
    }),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    defaultSortBy() {
      return [
        {
          column: 'taxYear',
          direction: 'desc',
        },
      ];
    },
    taxRollTypes() {
      const typeList = this.items(taxRollTypeCrudKey) || [];
      return [{ _id: null, adjType: '' }, ...typeList];
    },
    taxDistrictList() {
      const items = this.items(taxDistrictBaseCrudKey);
      const updatedItem = items.map((i) => ({
        ...i,
        taxDistrictCodeAndName: `${i.districtCode} ${i.districtName || ''}`,
      }));
      return [{ _id: null, taxDistrictCodeAndName: '' }, ...updatedItem];
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setCriteria',
      'setSelectedItemsOfAllPages',
    ]),
    handleLoadCRUDList(criteriaArgs = {}) {
      this.$emit('loadCRUDList', criteriaArgs);
    },
    dataFromCommonDropDowns(val, whichField) {
      if (whichField === 'taxAdjTypesList') {
        this.criteriaState.type = val;
      } else {
        this.criteriaState[whichField] = val;
      }
      this.searchByCriteria();
    },
    searchByCriteria() {
      this.setSelectedItemsOfAllPages([this.baseCrudKey, []]);
      const returnCriteria = makeCriteriaStateNullIfEmptyString(this.criteriaState);
      this.criteriaState = { ...returnCriteria };
      this.handleLoadCRUDList();
    },
    wildcardSearchDelayed() {
      // cancel pending call
      clearTimeout(this.delayTimerId);
      // delay new call
      this.delayTimerId = setTimeout(async () => {
        const criteriaArgs = { searchMode: 'wildcard' };
        await this.handleLoadCRUDList(criteriaArgs);
      }, SEARCH_DEBOUNCE_TIMER);
    },
    searchByTimeOutClarionDate(val) {
      clearTimeout(this.delayTimerId);

      // Helper function to validate MM-DD-YYYY date format
      const isValidDateFormat = (value) => {
        const dateRegex = /^(0?[1-9]|1[0-2])-(0?[1-9]|[12]\d|3[01])-\d{4}$/;
        return dateRegex.test(value);
      };

      if (!val || (val.includes('-') && isValidDateFormat(val))) {
        this.delayTimerId = setTimeout(async () => {
          try {
            await this.searchByCriteria();
          } catch (error) {
            console.error('Error in searchByCriteria:', error);
          }
        }, SEARCH_DEBOUNCE_TIMER);
      }
    },

    searchByTimeOutClarionDates(val) {
      clearTimeout(this.delayTimerId);
      if ((val && (val).includes('-')) || !val) {
        this.delayTimerId = setTimeout(async () => {
          this.searchByCriteria();
        }, SEARCH_DEBOUNCE_TIMER);
      }
    },
  },
};
</script>
